<ng-container *ngIf="eventType$ | async as eventType">
  {{ eventType.name }}
</ng-container>
